export default {
  SP: 35,
};
